"use client";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Title from "@/components/Title";
import {Black, White} from "@/styles/globalStyleVars";
import { Col, Container, Form, Row } from "react-bootstrap";
import Button from "@/components/Button";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { usePathname } from "next/navigation";
import Link from "next/link";
import axios from "axios";
import Cookies from "js-cookie";
import { Loading } from "@/components/Loading";

const MyComponent = () => {
  const location = usePathname();
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [selectResponseData, setSelectResponseData] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setIsSubmitting(false);
    }, 300);
  }, []);

  const { register, handleSubmit, formState, reset } = useForm({ mode: "all" });
  const { errors, isSubmitSuccessful } = formState;

  const success = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const error = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const onSubmit = async (data) => {
    setIsSubmitting(true); // Show spinner

    try {
      const formData = new FormData();
      formData.append("name", data?.name);
      formData.append("email", data?.email);
      formData.append("password", data?.password);

      const response = await axios.post(
        "https://cms.ucbstock.com.bd//wp-json/custom/v1/register",
        formData
      );
      setSelectResponseData(response)


      if (response.status === 200) {
        reset(); // Reset form fields
      }

    } catch (err) {

      error(err?.message ? "This email is already registered." : "Failed to submit form. Please try again later.");
    } finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  const onError = (errors) => {
    const firstError = Object.values(errors)[0];
    error(firstError.message);
  };

  useEffect(() => {
    if (selectResponseData?.error) {
      error(selectResponseData.error);
    }
    if (selectResponseData?.status === 200) {
      Cookies.set("user-token", selectResponseData?.data?.token, { expires: 7 });

      if(selectResponseData?.data?.user_id){
        success("Register successfully");
        setTimeout(() => {
          window.location.href = "/research/login";
        }, 1200)
      }
    }
  }, [selectResponseData]);

  return (
    <StyledComponent className={"user pt-200 pb-200"}>
      {isSubmitting && <Loading />}

      <Container>
        <Row>
          <Col sm={12}>
            <Title
              margin={"0 0 60px 0"}
              color={"#191919"}
              text={"User Sign Up"}
            />
          </Col>

          <Col md={6} sm={12}>
            <Form onSubmit={handleSubmit(onSubmit, onError)}>
              <Form.Group className={"from-group"}>
                <Form.Control
                  {...register("name", {
                    required: {
                      value: true,
                      message: "Enter your full name",
                    },
                  })}
                  type="text"
                  placeholder="Name*"
                />
                <p className={"form-error"}>{errors.name?.message}</p>
              </Form.Group>
              <Form.Group className={"from-group"}>
                <Form.Control
                  {...register("email", {
                    required: {
                      value: true,
                      message: "Enter a valid email address",
                    },
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Enter a valid email address",
                    },
                  })}
                  type="email*"
                  placeholder="Email*"
                />
                <p className={"form-error"}>{errors.email?.message}</p>
              </Form.Group>
              <Form.Group className={"from-group"}>
                <Form.Control
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Enter password",
                    },
                  })}
                  type="password"
                  placeholder="Password*"
                />
                <p className={"form-error"}>{errors.password?.message}</p>
              </Form.Group>
              <div
                style={{ width: "fit-content" }}
                onClick={handleSubmit(onSubmit, onError)}
              >
                <Button
                  src={"javascript:void(0)"}
                  margin={"60px 0 0 0"}
                  text={"Sign Up"}
                />
              </div>
            </Form>

            <div className="user-alter">
              <p>
                Already a User? <Link  prefetch={true} href={"/research/login"}> Login</Link>
              </p>

            </div>
          </Col>
        </Row>
      </Container>
    </StyledComponent>
  );
};

const StyledComponent = styled.section`
  //background-color: #08082B;
  background-color: #f4f4f4;

  //section {
  //  overflow: hidden;
  //  margin-bottom: -2px;
  //}

  .from-group {
    position: relative;

    .form-error {
      position: absolute;
      font-size: 10px;
      color: #ec1c23 !important;
      top: 100%;
    }

    margin-bottom: 25px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }

  .form-control {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #08082b;
    padding-left: 0;
    height: 45px;
    //margin-bottom: 25px;
    color: #191919;

    &:focus {
      border: none;
      border-bottom: 1px solid #191919 !important;
      border-color: #191919;
      outline: none;
      box-shadow: none;
    }

    &::placeholder {
      font-size: 15px;
      color: #191919;
    }
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: ${Black} !important;
    border-bottom: 1px solid ${Black};

    &:hover {
      border-bottom: 1px solid ${Black} !important;
    }

    &:focus {
      border-bottom: 1px solid #f5f5f5 !important;
    }
  }

  .user-alter {
    margin-top: 60px;

    p {
      color: #08082b;

      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }

    a {
      color: #ec1c24;
      text-decoration: underline;

      &:hover {
        color: #08082b !important;
      }
    }
  }
`;

export default MyComponent;
